import React, { useRef } from 'react';
import DashboardFooter from './DashboardFooter';
import BackToTop from './BackToTop';
import TaglineBar from '../FraudAlerts/components/TaglineBar';
import ReportRail from '../FraudAlerts/components/ReportRail';

// Standard Information Hub page shell: scroll container, tagline bar, main
// column and the Report rail. The layout <main> is overflow-hidden, so each
// page owns its own scrolling.
//
// The footer sits inside the main column so the innovation image lines up with
// the body width instead of running under the Report rail too.
//
// Wide screens (10-01): the row spans the full width so the Report rail stays
// pinned to the right edge, and the body is capped and centred within the
// space to its left. (A cap on the whole row used to centre body + rail as
// one block past ~2190px, which drifted the body right and pulled the rail
// off the edge.)
const BODY_MAX = 'max-w-[1520px]';

// Back to top (10-28): this div is the page's scroll container, so the
// control scrolls it rather than the window.
const HubPageLayout = ({ children }) => {
  const scrollRef = useRef(null);
  return (
    <div ref={scrollRef} data-hub-scroll className="h-full overflow-y-auto bg-white">
      <div className="flex gap-5 px-4 pt-6 pb-12 xl:gap-10 xl:px-8">
        <div className="flex-1 min-w-0 flex flex-col">
          <div data-hub-body className={`w-full ${BODY_MAX} mx-auto flex flex-col flex-1`}>
            <TaglineBar />
            {children}
            <DashboardFooter />
          </div>
        </div>
        <ReportRail />
      </div>
      <BackToTop scrollRef={scrollRef} />
    </div>
  );
};

export default HubPageLayout;
